import { Modal, Row, FormInstance, Col, Flex } from 'antd'

import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  tab: 'consumables' | 'medicine'
  form?: FormInstance
  productIndex: number
  onCancel: () => void
}

export const ConsumablesModal = ({
  form,
  productIndex,
  onCancel,
  tab
}: Props) => {
  const { t } = useLocales()

  const medicine = form?.getFieldValue([tab, productIndex])

  if (!medicine) {
    onCancel()
    return null
  }

  return (
    <Modal
      open
      centered
      maskClosable={false}
      title={t('stock_administration.product_details')}
      width={800}
      onCancel={onCancel}
      footer={false}
    >
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.commercial_naming')}
            </Text>
            <Text>{medicine?.name ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.group')}
            </Text>
            <Text>
              {medicine?.group ? t(`common.${medicine?.group}`) : '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.producer')}
            </Text>
            <Text>{medicine?.producerName ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('stock_administration.unit_price_with_tva')}
            </Text>
            <Text>{medicine?.tvaTotal ?? '-'}</Text>
          </Flex>
        </Col>
      </Row>
    </Modal>
  )
}
